// v5 — theme = dark | light, persisted to localStorage.
//
// v6-polish — theme state now lives in `usePreferences()`. This hook is
// kept as a thin adapter so existing callers (the App-level theme
// toggle button) don't need to know that the persistence layer moved.
// The DOM side-effect (toggling the `dark` class on <html>) is also
// hoisted into PreferencesProvider so theme class + persisted state
// share one source of truth.

import { usePreferences, type Theme } from './preferences';

export type { Theme };

export function useTheme(): {
  theme: Theme;
  setTheme: (t: Theme) => void;
  toggle: () => void;
} {
  const { prefs, setTheme, toggleTheme } = usePreferences();
  return {
    theme: prefs.theme,
    setTheme,
    toggle: toggleTheme,
  };
}